import styled from 'styled-components';
import { FieldPlaceholder } from '@salutejs/plasma-core';
export var Placeholder = /*#__PURE__*/styled(FieldPlaceholder).withConfig({
  componentId: "plasma-web-core__sc-n59jqr-0"
})(["--display:", ";display:inline-flex;align-items:center;padding:var(--padding-default);height:auto;font-size:var(--font-size);line-height:var(--line-height);font-weight:var(--plasma-typo-body-m-font-weight);input:not(:placeholder-shown) ~ &{display:var(--display);padding:var(--padding-placeholder-inactive);font-size:var(--placeholder-active-font-size);line-height:var(--placeholder-active-line-height);}"], function (_ref) {
  var visible = _ref.visible,
      withCaption = _ref.withCaption;

  if (withCaption || !visible) {
    return 'none';
  }

  return 'inline-flex';
});